import axios from '@/core/axios';
import { GradeV2 } from './grades-v2.types';

export class GradesV2Service {
  list(serial_no: string): Promise<GradeV2[]> {
    if (!serial_no) throw new Error('Missing serial_no in list');
    return axios.get<GradeV2[]>(`/grades-v2/list/${serial_no}`).then(resp => resp?.data);
  }

  get(gradeV2Id: number): Promise<GradeV2> {
    if (!gradeV2Id) throw new Error('Missing gradeV2Id in get');
    return axios.get<GradeV2>(`/grades-v2/${gradeV2Id}`).then(resp => resp?.data);
  }

  create(gradeV2: GradeV2): Promise<GradeV2> {
    return axios.post<GradeV2>(`/grades-v2`, { grading: gradeV2 }).then(resp => resp?.data);
  }

  calculNewGrade(gradeV2: GradeV2): Promise<GradeV2> {
    return axios.post<GradeV2>(`/grades-v2/calcul-new-grade`, { grading: gradeV2 }).then(resp => resp?.data);
  }

  update(gradeV2Id: number, gradeV2: GradeV2): Promise<GradeV2> {
    if (!gradeV2Id) throw new Error('Missing gradeV2Id in update');
    return axios.put<GradeV2>(`/grades-v2/${gradeV2Id}`, { grading: gradeV2 }).then(resp => resp?.data);
  }

  delete(gradeV2Id: number): Promise<void> {
    if (!gradeV2Id) throw new Error('Missing gradeV2Id in delete');
    return axios.delete(`/grades-v2/${gradeV2Id}`).then(resp => resp?.data);
  }
}

export const gradesV2Service = new GradesV2Service();
